"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallationId = getInstallationId;
const utils_1 = require("./utils");
function getInstallationId(installation) {
    // The database ID used for an installation is the serial number, which is calculated from the system fingerprint from `keyVersion` 6 onwards
    return (0, utils_1.cleanDocumentId)(installation.serialNumber);
}
//# sourceMappingURL=installations.js.map